import React, { useEffect, useState } from "react";
import "./MahadevTemples.css";

import mahakal from "../assets/mahakal.webp";
import secondImage from "../assets/shiv.webp";

// Place these files in public/assets.
// Rename the constants if your actual filenames are different.
import GURU_MAHARAJA_IMAGE from "../assets/images/mahadev/bcsswami.webp";
import SRILA_PRABHUPADA_IMAGE from "../assets/images/mahadev/prabhupada.webp";
import BOOK_COVER_IMAGE from "../assets/frontCoverImage.webp";

function splitTempleContent(longInfo = "") {
  const marker = "The complete account";
  const index = longInfo.toLowerCase().indexOf(marker.toLowerCase());

  if (index === -1) {
    return {
      summary: longInfo.trim(),
      completeAccount: "",
    };
  }

  return {
    summary: longInfo.slice(0, index).trim(),
    completeAccount: longInfo.slice(index).trim(),
  };
}

function MahadevTemples() {
  const [templesData, setTemplesData] = useState(() => {
    try {
      const cached = localStorage.getItem("templesData");

      if (cached) {
        const parsed = JSON.parse(cached);

        if (Array.isArray(parsed)) {
          return parsed;
        }
      }
    } catch (error) {
      console.error("Failed to read cached temple data:", error);
    }

    return [];
  });

  const [selectedTemple, setSelectedTemple] = useState(null);
  const [visibleTemples, setVisibleTemples] = useState(6);

  useEffect(() => {
    const API_URL =
      "https://script.google.com/macros/s/AKfycbzDzFoRtX73hktq8qdObTNdG7qInHdj4pm9v4-hemM0gA-uFaBkfc8fHcN_DMydIM9m/exec";

    const loadLatestTemples = async () => {
      try {
        console.log("Fetching latest temple data...");

        const response = await fetch(`${API_URL}?_ts=${Date.now()}`, {
          method: "GET",
          cache: "no-store",
        });

        if (!response.ok) {
          throw new Error(`API request failed: ${response.status}`);
        }

        const data = await response.json();

        if (!Array.isArray(data)) {
          throw new Error("Invalid temple data received from API");
        }

        console.log(`Latest temple data received: ${data.length} records`);

        // Update UI silently
        setTemplesData(data);

        // Save latest data
        localStorage.setItem("templesData", JSON.stringify(data));

        // Reset pagination
        setVisibleTemples(6);
      } catch (error) {
        console.error("Unable to refresh temple data:", error);

        // Do NOT clear the existing data.
        // Cached data remains visible.
      }
    };

    // Fetch in background.
    // Do not block the page.
    loadLatestTemples();
  }, []);
  /*
   * FULL CONTENT FROM INTRODUCTION.DOCX
   */

  const scriptureSections = [
    {
      icon: "✦",
      text: `In the introductory segment of the Avanti Khand of the Skanda Purana, Devi Parvati requests Lord Shiva, “Kindly enumerate the merits of the foremost sacred locations and rivers on Earth that may facilitate my attainment of faith and devotion.” In reply, Lord Shiva asserts, "Of all the rivers in this planetary system, the Ganges is the most revered, traversing three tributaries, through which she serves the devas, the Gandharvas, and the sages.`,
    },
    {
      icon: "✦",
      text: `The sacred Yamuna River, sister to Yamaraja, sanctifies the three worlds. She is revered by ancestors and renowned for her capacity to absolve the most grievous sins. The sacred rivers Chandrabhaga and Narmada, which originate from Amarkantaka, are honoured for their purifying qualities. The pilgrimage sites of Gaya, Prabhakshetra, and Kurukshetra are considered sacred locations. Other sacred locations, O Devi, encompass Kedar, Pushkara, and Kaya Avarohana. Moreover, the Mahakal Forest is the most sacred location where Shri Mahakaleshwara dwells; it is acknowledged for its ability to eliminate the motivation for sinful actions.`,
    },
    {
      icon: "✦",
      text: `The Mahakal Forest encompasses an expanse of four square yojanas, roughly equivalent to thirteen square kilometres. Even the most egregious sins, such as the killing of a Brahmin, are rendered null and void within its sacred boundaries. This sacred location functions as a source of sensual gratification and liberation, offering sanctuary from the detrimental impacts of the Kali-yuga era. Even the devas must surmount considerable obstacles to enter the Mahakal Forest, which maintains its sanctity despite enduring phases of complete destruction.`,
    },
    {
      icon: "✦",
      text: `O Devi, in Avantikapuri dwell the impeccable lingas, numbering eighty-four, accompanied by eight Bhairavas, who confer both sensual pleasure and emancipation. This sacred location houses eleven Rudras, twelve Adityas, six Vinayaks, and twenty-four Matrkas.`,
    },
    {
      icon: "✦",
      text: `During my visit to the renowned Mahakal forest, I had the honour of encountering Brahma, Vishnu, and other deities. The influence of these formidable figures resulted in the enlargement of the Mahakal forest, converting the area linked to Vishnu into a cleanser of all transgressions. Individuals who recall Vishnu and recite His names at these locations achieve liberation from their previous sins and attain Rudraloka.`,
    },
    {
      icon: "✦",
      text: `Devi Parvati then requests Lord Shiva to recount the unique pastimes associated with each of the eighty-four Shiva lingas. In reply, the Lord begins to elucidate the splendour of these powerful lingas, renowned for their ability to absolve sin and grant liberation. These pastimes are summarised in this book.`,
    },
  ];

  /*
   * AUTHOR'S NOTE FROM PAGE 3
   */

  const authorNote = [
    `I would like to express my sincere and heartfelt gratitude to my Guru Maharaja, His Holiness Bhakti Charu Swami Maharaja, who inspired me to compile this book.`,
    `I am eternally indebted to him for his unwavering support, encouragement, and guidance throughout my life.`,
    `Additionally, I wish to convey my deep appreciation to my param Guru, His Divine Grace A.C. Bhaktivedanta Swami Prabhupada, the founder of the International Society for Krishna Consciousness (ISKCON), for without him, I would not have been able to embark on the path of Krishna Bhakti.`,
  ];

  // The featured temple section is intentionally disabled.
  // Show the complete collection directly in the temple grid.
  const remainingTemples = templesData;

  const displayedTemples = remainingTemples.slice(0, visibleTemples);

  const hasMoreTemples = visibleTemples < remainingTemples.length;

  const handleLoadMore = () => {
    setVisibleTemples((previous) => previous + 6);
  };

  const openTemple = (temple) => {
    setSelectedTemple(temple);
    document.body.classList.add("mahadev-modal-open");
  };

  const closeTemple = () => {
    setSelectedTemple(null);
    document.body.classList.remove("mahadev-modal-open");
  };

  useEffect(() => {
    const preventImageActions = (event) => {
      if (event.target?.tagName === "IMG") {
        event.preventDefault();
      }
    };

    document.addEventListener("contextmenu", preventImageActions);
    document.addEventListener("dragstart", preventImageActions);

    return () => {
      document.removeEventListener("contextmenu", preventImageActions);
      document.removeEventListener("dragstart", preventImageActions);
    };
  }, []);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeTemple();
      }
    };

    if (selectedTemple) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [selectedTemple]);

  useEffect(() => {
    return () => {
      document.body.classList.remove("mahadev-modal-open");
    };
  }, []);

  const selectedTempleContent = selectedTemple
    ? splitTempleContent(selectedTemple.longInfo || "")
    : null;

  return (
    <main className="mahadev-page">
      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="mahadev-hero">
        <div className="mahadev-container">
          <div className="hero-grid">
            <div className="hero-content">
              <span className="eyebrow">A SACRED LEGACY</span>

              <h1>
                Avantikapura’s
                <br />
                <span>84 Mahadevas</span>
              </h1>

              <div className="decorative-divider">
                <span>✧</span>
              </div>

              <p className="hero-lead">
                Shri Nandiswara, in the Shiva Purana, elucidates the twelve
                Jyotirlingas of Lord Shiva.
              </p>

              <p>
                Shri Mahakaleshwara Mahadeva, a prominent Jyotirlinga, is in the
                Mahakal forest (Avantikapuri, Ujjain, or Ujjaiyani).
                Additionally, there are eighty-four other significant Shiva
                lingas in Avantikapuri, each linked to unique historical
                accounts, as recorded in the Avanti Khand of the Skanda Purana
                (5.2.1-84).
              </p>

              <p>
                Avantikapuri is recognised as one of the seven ancient cities
                (Sapta Puris) that grant liberation, as stated in the Garuda
                Purana, within the sacred region of Bharata.
              </p>
            </div>

            {/* FIRST IMAGE */}

            <div className="hero-image-card">
              <div className="hero-image-wrapper">
                <img
                  src={mahakal}
                  alt="Shri Mahakaleshwara Mahadeva"
                  width="804"
                  height="576"
                  loading="eager"
                  fetchPriority="high"
                  decoding="async"
                />
              </div>

              <div className="hero-image-caption">
                <div className="caption-icon">
                  {" "}
                  <span>✧</span>
                </div>

                <div>
                  <strong>Shri Mahakaleshwara Mahadeva,</strong>

                  <span>the presiding Deity of Mahakal Vana.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          SCRIPTURE CONTENT
      ===================================================== */}

      <section className="scripture-section">
        <div className="mahadev-container">
          <div className="scripture-intro">
            <span className="eyebrow">THE SACRED NARRATIVE</span>

            <h2>The Glories of Avantikapuri</h2>
          </div>

          <div className="scripture-grid">
            {scriptureSections.slice(0, 4).map((section, index) => (
              <article className="scripture-item" key={index}>
                <div className="scripture-icon">{section.icon}</div>

                <div>
                  <p>{section.text}</p>
                </div>
              </article>
            ))}
          </div>

          {/* =================================================
              SECOND IMAGE
          ================================================= */}

          <div className="narration-feature">
            <div className="narration-image">
              <img
                src={secondImage}
                alt="Lord Shiva narrating to Devi Parvati the glories of 84 Mahadevas of Avantikapuri"
              />
            </div>

            <div className="narration-caption">
              <span className="caption-line"></span>

              <p>
                Lord Shiva narrating to Devi Parvati
                <br />
                the glories of 84 Mahadevas of Avantikapuri
              </p>

              <span className="caption-line"></span>
            </div>
          </div>

          {/* =================================================
              REMAINING FULL TEXT
          ================================================= */}

          <div className="remaining-scripture">
            {scriptureSections.slice(4).map((section, index) => (
              <article className="full-text-block" key={index}>
                <div className="scripture-icon">{section.icon}</div>

                <p>{section.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
          GRATITUDE + DEDICATION
      ===================================================== */}

      <section className="author-section">
        <div className="mahadev-container">
          <div className="gratitude-card">
            <div className="gratitude-heading">
              <span className="eyebrow">A NOTE OF GRATITUDE</span>
              <h2>With Sincere Gratitude &amp; Dedication</h2>
              <div className="author-divider">
                <span>✧</span>
              </div>
            </div>

            <div className="gratitude-grid">
              <article className="gratitude-person">
                <div className="gratitude-photo">
                  <img
                    src={GURU_MAHARAJA_IMAGE}
                    alt="His Holiness Bhakti Charu Swami Maharaja"
                    loading="lazy"
                    draggable="false"
                  />
                </div>
                <div className="gratitude-person-content">
                  <span className="gratitude-role">
                    DEDICATED WITH GRATITUDE TO
                  </span>
                  <h3>His Holiness Bhakti Charu Swami Maharaja</h3>
                  <p>
                    I would like to express my sincere and heartfelt gratitude
                    to my Guru Maharaja, His Holiness Bhakti Charu Swami
                    Maharaja, who inspired me to compile this book.
                  </p>
                  <p>
                    I am eternally indebted to him for his unwavering support,
                    encouragement, and guidance throughout my life.
                  </p>
                </div>
              </article>

              <article className="gratitude-person">
                <div className="gratitude-photo">
                  <img
                    src={SRILA_PRABHUPADA_IMAGE}
                    alt="His Divine Grace A.C. Bhaktivedanta Swami Prabhupada"
                    loading="lazy"
                    draggable="false"
                  />
                </div>
                <div className="gratitude-person-content">
                  <span className="gratitude-role">
                    OFFERED WITH DEEP APPRECIATION TO
                  </span>
                  <h3>His Divine Grace A.C. Bhaktivedanta Swami Prabhupada</h3>
                  <p>
                    Additionally, I wish to convey my deep appreciation to my
                    param Guru, His Divine Grace A.C. Bhaktivedanta Swami
                    Prabhupada, the founder of the International Society for
                    Krishna Consciousness (ISKCON), for without him, I would not
                    have been able to embark on the path of Krishna Bhakti.
                  </p>
                </div>
              </article>
            </div>

            <div className="author-name">Bimal Krishna Das</div>
          </div>
        </div>
      </section>

      {/* =====================================================
          BOOK COVER
      ===================================================== */}

      <section className="book-cover-section">
        <div className="mahadev-container">
          {/* <div className="book-cover-heading">
            <span className="eyebrow">THE BOOK</span>
            <h2>Avantikapuri’s 84 Mahadevas</h2>
           
          </div> */}

          <div className="book-cover-card">
            <div className="book-cover-image">
              <img
                src={BOOK_COVER_IMAGE}
                alt="Front cover of Avantikapuri’s 84 Mahadevas"
                loading="lazy"
                decoding="async"
              />
            </div>

            <div className="book-cover-copy">
              <span className="eyebrow">THE BOOK</span>
              <h3>Avantikapuri’s 84 Mahadevas</h3>
              <p>
                This book presents the divine pastimes, significance and
                traditions associated with each of the eighty-four sacred
                Mahadevas of Avantikapuri.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          TEMPLE COLLECTION
      ===================================================== */}

      {remainingTemples.length > 0 && (
        <section className="temples-section">
          <div className="mahadev-container">
            <div className="section-heading">
              <span className="eyebrow">SACRED SHRINES</span>

              <h2>Explore the 84 Mahadevas</h2>

              <p>
                Discover the sacred stories, traditions and significance
                associated with each Mahadeva.
              </p>
            </div>

            <div className="temple-grid">
              {displayedTemples.map((temple, index) => (
                <article
                  key={temple.id || index}
                  className="temple-card"
                  role="button"
                  tabIndex={0}
                  aria-label={`Explore ${temple.name || "Mahadeva shrine"}`}
                  onClick={() => openTemple(temple)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      openTemple(temple);
                    }
                  }}
                >
                  <div className="temple-image-wrapper">
                    {temple.image1 ? (
                      <img
                        src={temple.image1}
                        alt={temple.name || "Mahadeva shrine"}
                        className="temple-icon"
                        loading="lazy"
                        decoding="async"
                      />
                    ) : (
                      <div className="temple-placeholder">ॐ</div>
                    )}

                    <span className="temple-number">{index + 1} / 84</span>
                  </div>

                  <div className="temple-card-content">
                    <h3>{temple.name || "Mahadeva Shrine"}</h3>

                    <p>
                      {temple.shortInfo ||
                        "Sacred Mahadeva shrine of Avantikapuri."}
                    </p>

                    <span className="card-link" aria-hidden="true">
                      Explore
                      <strong>→</strong>
                    </span>
                  </div>
                </article>
              ))}
            </div>

            {hasMoreTemples && (
              <div className="load-more-wrapper">
                <button
                  type="button"
                  className="load-more-btn"
                  onClick={handleLoadMore}
                >
                  Load More
                  <strong>↓</strong>
                </button>

                <p>
                  Showing {displayedTemples.length} of {remainingTemples.length}{" "}
                  sacred shrines
                </p>
              </div>
            )}
          </div>
        </section>
      )}

      {/* =====================================================
          POPUP
      ===================================================== */}

      {selectedTemple && (
        <div className="popup-overlay" onClick={closeTemple}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="close-btn" onClick={closeTemple}>
              ×
            </button>

            <div className="popup-header">
              <span>SACRED SHRINE</span>

              <h2>{selectedTemple.name}</h2>
            </div>

            {[
              selectedTemple.image1,
              selectedTemple.image2,
              selectedTemple.image3,
            ].some(Boolean) && (
              <div className="popup-images">
                {[
                  selectedTemple.image1,
                  selectedTemple.image2,
                  selectedTemple.image3,
                ].map(
                  (img, index) =>
                    img && (
                      <img
                        key={`${selectedTemple.id || selectedTemple.name}-${index}`}
                        src={img}
                        alt={`${selectedTemple.name || "Mahadeva shrine"} ${index + 1}`}
                        loading="lazy"
                        decoding="async"
                      />
                    ),
                )}
              </div>
            )}

            <div className="popup-body">
              {selectedTemple.longInfo && (
                <div className="popup-section">
                  <h3>Summary</h3>

                  {selectedTempleContent?.summary
                    .split("\n")
                    .filter((line) => line.trim())
                    .map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}

                  {selectedTempleContent?.completeAccount && (
                    <p className="complete-account">
                      <strong>The complete account of</strong>
                      {selectedTempleContent.completeAccount.replace(
                        /^The complete account of\s*/i,
                        " ",
                      )}
                    </p>
                  )}
                </div>
              )}

              {selectedTemple.benefits && (
                <div className="popup-section">
                  <h3>Spiritual Significance</h3>

                  <ul>
                    {selectedTemple.benefits
                      .split(",")
                      .map((benefit, index) => (
                        <li key={index}>{benefit.trim()}</li>
                      ))}
                  </ul>
                </div>
              )}

              {selectedTemple.location && (
                <div className="popup-location">
                  <strong>Location</strong>

                  <span>{selectedTemple.location}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default MahadevTemples;
